import { Layout } from "antd";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes.jsx";
import Header from "./components/header/Header.jsx";
import Footer from "./components/footer/Footer.jsx";
import { StatusProvider } from "./context/StatusContext";
import ScrollToTop from "./ScrollToTop.jsx";
import "./App.css";

const { Content } = Layout;

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <StatusProvider>
        <Layout className="app-layout">
          <Header />
          <Content>
            <AppRoutes />
          </Content>
          <Footer />
        </Layout>
      </StatusProvider>
    </BrowserRouter>
  );
}

export default App;
